module.exports = __webpack_public_path__ + "media/images/app/testimonials/header-mobile-bb8c5cf92992dda4e2cc6c52ae4acd2f.webp";